<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Datenschutzrichtlinie" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Xero Place Co., Ltd. (im Folgenden „das Unternehmen“ genannt) verlangt von den Benutzern die Angabe eines Mindestmaßes an persönlichen Daten, damit sie die Website bedenkenlos nutzen können.</span>
            <span class="text">Darüber hinaus legen wir größten Wert darauf, die uns zur Verfügung gestellten personenbezogenen Daten zu schützen.</span>
            <span class="text">Der Ansatz unseres Unternehmens zum Schutz personenbezogener Daten ist wie folgt.</span>
            <br>
            <span class="text">(1) Das Unternehmen wird die Informationen von Einzelpersonen, Organisationen und Unternehmen, die von Mitgliedern registriert wurden, nur zur Entwicklung und Bereitstellung modernster Funktionen und Dienste verwenden und wird dem Schutz der persönlichen Daten der Mitglieder große Aufmerksamkeit schenken.</span>
            <span class="text">(2) Diese Datenschutzerklärung gilt nur für die Leistungen unseres Unternehmens.</span>
            <span class="text">(3) Sofern in diesen Bedingungen nicht anders angegeben, werden die Informationen nicht für andere Zwecke verwendet.</span>
            <span class="text">(4) Sofern in diesen Bedingungen nicht anders angegeben, werden wir Ihre Daten nicht an Dritte weitergeben.</span>
            <span class="text">(5) Wir werden regelmäßig eine angemessene Verwaltung unter Verwendung anderer in diesen Bedingungen festgelegter Methoden durchführen.</span>
            <span class="text">(6) Unser Unternehmen kann die Datenschutzerklärung ohne Zustimmung des Nutzers ändern.</span>
            <span class="text">Wenn unser Unternehmen Änderungen am Inhalt der erfassten personenbezogenen Daten, an den Verwendungsmethoden, am Inhalt der Offenlegung usw. vornimmt, benachrichtigen wir Sie, indem wir einen Hinweis auf unserer Website veröffentlichen und ihn in dieser Datenschutzrichtlinie widerspiegeln, damit Benutzer über den Inhalt informiert werden.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Abschnitt 1. Geltungsbereich unserer Datenschutzerklärung</span>
            <span class="text">(1) Bei der Nutzung unserer Dienste durch Mitglieder gelten unsere Datenschutzbestimmungen.</span>
            <span class="text">(2) Persönliche Daten, die bei der Nutzung unserer Dienste durch Mitglieder erfasst werden, werden in Übereinstimmung mit der Richtlinie unseres Unternehmens zum Schutz personenbezogener Daten verwaltet.</span>
            <span class="text">(3) Unsere Richtlinie zum Schutz personenbezogener Daten gilt nur für Dienstleistungen, die direkt von unserem Unternehmen bereitgestellt werden, und gilt nicht für Dienstleistungen, die von anderen Organisationen oder Unternehmen bereitgestellt werden.</span>
            <span class="text">(4) Die Nutzung unserer Dienste erfolgt auf eigene Gefahr des Nutzers.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Abschnitt 2. Erhebung und Nutzung unserer personenbezogenen Daten</span>
            <span class="text">(1) Zur Entwicklung und Bereitstellung modernster Funktionen und Dienste für unsere Mitglieder benötigen wir einige personenbezogene Daten unserer Nutzer.</span>
            <span class="text">(2) Der Nutzer ist für die Verwaltung seiner registrierten E-Mail-Adresse und seines Passworts verantwortlich.</span>
            <span class="text">1. Ändern Sie Ihr Passwort regelmäßig. Wir raten davon ab, Namen, Geburtsdaten, Telefonnummern usw. zu verwenden, die für andere leicht zu erraten sind.</span>
            <span class="text">2. Bitte geben Sie Ihre persönlichen Daten nicht weiter, verleihen oder übermitteln Sie sie nicht, auch nicht an einen Bekannten oder Freund.</span>
            <span class="text">(3) Die erhobenen personenbezogenen Daten werden von uns nur im für die Erbringung unserer Leistungen erforderlichen Umfang genutzt und nicht an Dritte weitergegeben, außer in den folgenden Fällen.</span>
            <span class="text">1. Wenn ein Kreditkartenunternehmen eine Anfrage zur Untersuchung einer betrügerischen Kartennutzung stellt.</span>
            <span class="text">2. Beim Versenden von E-Mails etc. zur Werbung an Mitglieder.</span>
            <span class="text">3. Bei der Beauftragung eines Subunternehmers mit der Verarbeitung personenbezogener Daten, mit dem wir eine Geheimhaltungsvereinbarung über personenbezogene Daten abgeschlossen haben, soweit dies zur Erreichung des dem Nutzer angegebenen Verwendungszwecks erforderlich ist.</span>
            <span class="text">4. Wenn es als notwendig erachtet wird, die Rechte oder das Eigentum anderer Mitglieder, Dritter oder des Unternehmens zu schützen, falls die Handlungen eines Mitglieds im Unternehmen gegen die Richtlinien, Ankündigungen oder Nutzungsbedingungen des Unternehmens verstoßen.</span>
            <span class="text">5. Wenn die Offenlegung personenbezogener Daten gemäß den Bestimmungen anderer Gesetze, wie z. B. Anordnungen eines Gerichts oder einer Verwaltungsbehörde, verlangt wird oder wenn eine strafrechtliche Untersuchung, die Beseitigung oder Verhinderung von Rechtsverletzungen Dritter oder eine andere ähnliche Notwendigkeit erforderlich ist.</span>
            <span class="text">(4) Mitglieder stimmen der Verwendung personenbezogener Daten durch das Unternehmen in der oben genannten Weise im Voraus zu und können keine Einwände erheben.</span>
            <span class="text">(5) Darüber hinaus können wir in folgenden Fällen personenbezogene Daten unserer Mitglieder an unsere Geschäftspartner weitergeben:</span>
            <span class="text">1. Wenn ein geschäftlicher Grund vorliegt, beispielsweise besondere Dienstleistungen für Mitglieder. In diesem Fall werden wir vor der Bereitstellung der Informationen die Zustimmung des Mitglieds einholen und die Informationen nicht ohne dessen Zustimmung weitergeben.</span>
            <span class="text">2. Bei der Erstellung statistischer Materialien, der Durchführung von Marktforschungen oder der Durchführung von Datenanalysen. In diesem Fall geben wir nur solche Informationen weiter, die so verarbeitet wurden, dass keine Rückschlüsse auf bestimmte Personen möglich sind.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
